<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     tag?: string,
     *     inx?: number,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { tag = 'dt', inx = 0, children } = $props();

    /** @type {{ [key: string]: string }} */
    const allowedTags = {
        dt: 'dt',
        span: 'span',
    };
    const thisTag = $derived(allowedTags[ValueService.toStringSingleLine(tag)] ?? 'dt');
    const thisNumber = $derived(ValueService.toInt(inx));
</script>

<svelte:element this={thisTag} class="lyListKey {thisNumber % 2 ? 'lyListOdd' : 'lyListEven'} float-left clear-both">
    <span class="small-caps text-sm">
        {@render children?.()}
    </span>
</svelte:element>
